import React from "react";

const Health = () => {
   return(<h1>This is Health</h1>);
};
export default Health;